import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { mc } from "../characters/MC";
import { V9VanessaBusAfter } from "./V9";
import { vanessa } from "../characters/Vanessa";
import { cashier } from "../characters/Cashier";
import { doLoopImages, doTransition, doWaitImageByTime, isAgreedToChrisProposal, isFollowingVanessaLead } from "../helpers/helpers";
import { stranger } from "../characters/Stranger";
import Game from "../../src/shell/Game";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";
const v9 = images.v9;
export const V9VanessaBus = async (): Promise<any> => {
    doTransition(images.v9.V9VanessaMCOutside_10);
    vanessa.talk(`This should be the right stop.`);
    doWaitImageByTime(v9.V9VanessaMCOutside_0);
    mc.talk(`I honestly thought you are shitting me about taking the bus.`);
    mc.talk(`I was sure you could always find someone to drive you wherever you wanted to go.`);
    doWaitImageByTime(v9.V9VanessaMCOutside_2);
    vanessa.talk(`That's sexist!`);
    ImageClass.setImage(images.v9.V9VanessaMCOutside_1);
    mc.talk(`Can you really blame me?`);
    ImageClass.setImage(v9.V9VanessaMCOutside_2);
    vanessa.talk(`I just did.`);
    ImageClass.setImage(images.v9.V9VanessaMCOutside_1);
    if (isFollowingVanessaLead()) {
        mc.talk(`So... Are you going to tell me what you are planning?`);
        ImageClass.setImage(v9.V9VanessaMCOutside_2);
        vanessa.talk(`No.`);
        ImageClass.setImage(v9.V9VanessaMCOutside_1);
    } else {
        mc.talk(`So... Are you going to tell me what to do?`);
        ImageClass.setImage(v9.V9VanessaMCOutside_2);
        vanessa.talk(`Whatever you want.`);
        mc.talk(`Like?`);
        ImageClass.setImage(images.v9.V9VanessaMCOutside_1);
        vanessa.talk(`Do you really expect me to help you? I'm waiting for you to lose so you'll then have to do whatever I say.`);
    }
    mc.talk(`...`);
    mc.talk(`So... Now what?`);
    ImageClass.setImage(v9.V9VanessaMCOutside_3);
    vanessa.talk(`Now... We wait.`);

    doWaitImageByTime(v9.V9VanessaMCOutside_4);
    if (isFollowingVanessaLead()) {
        mc.think(`What the hell is she planning?`);
    } else {
        mc.think(`I wonder what she expects me to do.`);
        mc.think(`She did say she'd follow me lead...`);
    }
    doWaitImageByTime(v9.V9VanessaMCOutside_6);
    mc.talk(`I guess we'll just sit quietly.`);
    doWaitImageByTime(v9.V9VanessaMCOutside_7);
    mc.talk(`...`);
    doWaitImageByTime(v9.V9VanessaMCOutside_5, { wait: true });
    doWaitImageByTime(v9.V9VanessaMCOutside_9);
    vanessa.talk(`Here it comes.`);

    // on bus
    doWaitImageByTime(v9.V9VanessaMCOutsideBus_29);
    vanessa.talk(`Go ahead inside, it's on me this time.`);
    doWaitImageByTime(v9.V9VanessaMCOutsideBus_30);
    mc.think(`I can't believe it's that lady again!`);
    mc.think(`How many fucking jobs does she have?`);
    mc.think(`That look...`);

    // Sitting
    doWaitImageByTime(v9.V9VanessaMCOutsideBus_31, { hideText: true, wait: true });
    doWaitImageByTime(v9.V9VanessaMCOutsideBus_1);
    mc.talk(`Are you sure you don't want a dollar?`);


    // doLoopImages([images.v9.V9VanessaMCOutsideBus_1, images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_33, images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_34]);



    // ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_32);
    if (Question.globalAnswers.v7VanessaGiveCustomerWhatHeWants === true) {
        vanessa.talk(`I got my job back, so no.`);
    } else if (Question.globalAnswers.v7VanessaGiveCustomerWhatHeWants === false) {
        if (Question.globalAnswers.v8FuckedAngela) {
            vanessa.talk(`You helped me get my job back, so I can effort it now!`);
        } else {
            vanessa.talk(`I got my job back... No thanks to you by the way!`);
            ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1);
            mc.talk(`Oh right! You never told me what happened.`);
            ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_32);
            vanessa.talk(`I'll tell you later, I need you focused right now.`);



        }
    } else {
        ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_32);
        vanessa.talk(`Unlike you, I have a job.`);
        ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1);
        mc.talk(`...`);
    }

    // Bus driving.

    ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_33);
    vanessa.talk(`So what does Chris want from you anyways?`);
    ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1);
    if (isAgreedToChrisProposal()) {
        mc.talk(`You'll see.`);

    } else {
        mc.talk(`I have no idea. I guess we are about to find out.`);
    }
    if (isFollowingVanessaLead()) {
        return jump(V9VanessaBus_VanessaLeadingBet, "V9VanessaBus_VanessaLeadingBet");
    } else {

    }
    return jump(V9VanessaBus_MCLeadingBet, "V9VanessaBus_MCLeadingBet");

};
export const V9VanessaBus_VanessaLeadingBet = async (): Promise<any> => {
    // cheeky smile
    ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_34);
    vanessa.talk(`In the mean time, I know how we can pass the time.`);
    mc.talk(`Uh-oh...`);
    doWaitImageByTime(v9.V9VanessaMCOutsideBus_2);
    mc.talk(`What are you planning?`);
    vanessa.talk(`What does it look like I'm doing?`);
    doWaitImageByTime(v9.V9VanessaMCOutsideBus_3);

    vanessa.talk(`What are you waiting for?`);
    mc.talk(`You are insane you know that?`);
    vanessa.talk(`So?`);
    mc.think(`A bet is a bet I guess...`);
    // MC lowering pants
    doWaitImageByTime(v9.V9VanessaMCOutsideBus_4, { wait: true });
    doWaitImageByTime(v9.V9VanessaMCOutsideBus_17);
    vanessa.talk(`You actually did it!`);
    ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_19);
    vanessa.talk(`What about...`);
    doWaitImageByTime(v9.V9VanessaMCOutsideBus_27);
    vanessa.talk(`... this...?`);
    mc.think(`I've gone this far...`);
    doWaitImageByTime(v9.V9VanessaMCOutsideBus_26);
    mc.think(`I'm so exposed here.`);
    doWaitImageByTime(v9.V9VanessaMCOutsideBus_28);
    mc.think(`But I can't say it's not exciting...`);
    mc.think(`Vanessa definitely knows how to pass the time on the bus.`);
    doWaitImageByTime(v9.V9VanessaMCOutsideBus_20);
    vanessa.talk(`Let me help you...`);
    doWaitImageByTime(v9.V9VanessaMCOutsideBus_21);
    vanessa.talk(`How does that feel?`);
    mc.talk(`I'm not complaining...`);
    mc.talk(`But--`);

    ImageClass.setImage(images.v9.Anim_V9VanessaMCOutsideBusStorking.poster);
    vanessa.talk(`Shh....`);
    ImageClass.setAnimation(images.v9.Anim_V9VanessaMCOutsideBusStorking);
    mc.think(`Fuck!`);
    mc.think(`Knowing that someone can turn around at any second and see us makes me want to explode!`);

    mc.talk(`Fuck...`);
    // MC about to cum
    if (Question.globalAnswers.v1EnableNTR) {
        ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_35);
        mc.talk(`Vanessa, someone is coming!`);
        vanessa.talk(`I know. I'm working on it!`);
        mc.talk(`No! Someone is approaching us!`);
        vanessa.talk(`Oh!`);
        vanessa.talk(`Move to another sit so you can watch and learn!`);
        mc.talk(`Are you serious?`);
        vanessa.talk(`Do it already! He's going to sit somewhere else!`);

        return jump(v9VanessaBusMcMovedSeat, "v9VanessaBusMcMovedSeat");





    } else {
        vanessa.talk(`Oh look! It's our stop.`);
        mc.talk(`Are you fucking kidding me?`);
        vanessa.talk(`No! Look.`);
        mc.think(`God damnit.`);

    }



    return jump(V9VanessaBus_End, "V9VanessaBus_End");
};
export const V9VanessaBus_MCLeadingBet = async (): Promise<any> => {
    mc.think(`Now could be the perfect time to put this bet of ours to good use.`);
    await mc.setQuestion(new Question({ text: `There are so many opportunities... I wonder what I should do with her...`, options: { think: true }, key: `v9VanessaBusMcLeadingOptions` })
        .option({ title: `Make her undress`, key: "undress" })
        .option({ title: `Move to another seat`, key: "moveSeat", show: Question.globalAnswers.v1EnableNTR })
        .option({ title: `Just wait for your stop`, key: "doNothing" }));


    if (Question.globalAnswers.v9VanessaBusMcLeadingOptions === "undress") {
        mc.talk(`I think it's time to see if you're serious.`);
        ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_32);
        vanessa.talk(`I figured you'd know me by now.`);
        ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_34);
        mc.talk(`Alright. So start by lifting up your shirt.`);
        ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_33);
        vanessa.talk(`Oh no. That's not how it works!`);
        vanessa.talk(`I should try and act like you.`);
        ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_36);
        vanessa.talk(`If removing your clothes in buses is something you usually do. So go ahead and I'll do the same.`);

        mc.think(`She's piqued my curiosity...`);
        doWaitImageByTime(v9.V9VanessaMCOutsideBus_4);
        mc.think(`Let's see how far she'll take it.`);
        doWaitImageByTime(v9.V9VanessaMCOutsideBus_17);
        vanessa.talk(`Oh wow!`);
        ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_36);
        vanessa.talk(`I thought you were fucking with me!`);
        mc.talk(`Well?`);
        doWaitImageByTime(v9.V9VanessaMCOutsideBus_2);
        vanessa.talk(`A bet is a bet.`);
        mc.talk(`Well... I exposed all my intimate parts and you didn't.`);
        doWaitImageByTime(v9.V9VanessaMCOutsideBus_19);
        vanessa.talk(`Haha, fine, I'll play along.`);
        await mc.setQuestion(new Question({ text: `I wonder...`, options: { think: true }, key: `v9VanessaBusMcLeadingAskHerToTouchCock` })
            .option({ title: `Touch my dick`, key: true })
            .option({ title: `Start masturbating`, key: false }));


        if (Question.globalAnswers.v9VanessaBusMcLeadingAskHerToTouchCock) {
            mc.talk(`Touch my dick.`);
            doWaitImageByTime(images.v9.V9VanessaMCOutsideBus_21);
            vanessa.talk(`Now you are talking!`);
            doWaitImageByTime(images.v9.V9VanessaMCOutsideBus_20);
            vanessa.talk(`For a second there I thought it was going to be a boring ride.`);
            mc.talk(`Just keep going.`);
            ImageClass.setImage(images.v9.Anim_V9VanessaMCOutsideBusStorking.poster);
            vanessa.talk(`With pleasure!`);
            ImageClass.setAnimation(images.v9.Anim_V9VanessaMCOutsideBusStorking);
            mc.think(`Fuck!`);
            doWaitImageByTime(images.v9.V9VanessaMCOutsideBus_35);

        } else {
            doLoopImages([images.v9.V9VanessaMCOutsideBus_26, images.v9.V9VanessaMCOutsideBus_18], 0.6, 0);
            mc.think(`Let's see if she'll play along with this.`);
            doWaitImageByTime(v9.V9VanessaMCOutsideBus_27);
            mc.think(`She is.`);
            doWaitImageByTime(v9.V9VanessaMCOutsideBus_28.partials.V9VanessaMCOutsideBus_28_p);


        }
        if (Question.globalAnswers.v1EnableNTR) {
            await mc.setQuestion(new Question({ text: `Oh shit! Someone's coming!`, options: { think: true }, key: `v9VanessaBusMcLeadingMasturbateMovedSeat` })
                .option({ title: `Move to a different seat`, key: true })
                .option({ title: `Stay put`, key: false }));


            if (Question.globalAnswers.v9VanessaBusMcLeadingMasturbateMovedSeat) {
                return jump(v9VanessaBusMcMovedSeat, "v9VanessaBusMcMovedSeat");
            } else {
                return jump(v9VanessaBusMcLeadingOptionsStayPut, "v9VanessaBusMcLeadingOptionsStayPut");
            }

        } else {
            mc.talk(`Oh shit! Someone's coming!`);
            return jump(v9VanessaBusMcLeadingOptionsStayPut, "v9VanessaBusMcLeadingOptionsStayPut");

        }

    } else if (Question.globalAnswers.v9VanessaBusMcLeadingOptions === "moveSeat") {
        return jump(v9VanessaBusMcMovedSeat, "v9VanessaBusMcMovedSeat");
    }

    return jump(V9VanessaBus_End, "V9VanessaBus_End");
};
export const v9VanessaBusMcMovedSeat = async (): Promise<any> => {
    if (isFollowingVanessaLead()) {
        doWaitImageByTime(images.v9.V9VanessaMCOutsideBus_6);
        mc.think(`I had a feeling she wouldn't let me cum that easily.`);
    } else if (Question.globalAnswers.v9VanessaBusMcLeadingMasturbateMovedSeat) {
        doWaitImageByTime(v9.V9VanessaMCOutsideBus_6);
        mc.think(`I could kept it going, but I'm too curious to see what will happen next...`);
        doWaitImageByTime(v9.V9VanessaMCOutsideBus_5);
        mc.think(`What's that look? It's like she knows something that I don't...`);

    } else {
        doWaitImageByTime(v9.V9VanessaMCOutsideBus_5);
        vanessa.talk(`I like the way you are thinking.`);
        mc.think(`I fell like she knows something that I don't.`);
        doWaitImageByTime(images.v9.V9VanessaMCOutsideBus_6);
        mc.think(`Someone's coming.`);

    }

    doWaitImageByTime(images.v9.V9VanessaMCOutsideBus_7);
    mc.think(`It seems like he's gonna sit right in front of her...`);
    doWaitImageByTime(images.v9.V9VanessaMCOutsideBus_8);
    mc.think(`Yup...`);
    if (isFollowingVanessaLead()) {
        mc.think(`Time to see what she is planning.`);
    } else {
        mc.think(`Let's see what happens now...`);
    }
    doWaitImageByTime(images.v9.V9VanessaMCOutsideBus_9);
    if (isFollowingVanessaLead()) {
        mc.think(`She goes right in it seems.`);
    } else {
        mc.think(`As expected...`);
    }
    doWaitImageByTime(images.v9.V9VanessaMCOutsideBus_10);
    mc.think(`He doesn't realize what's happening...`);
    doWaitImageByTime(images.v9.V9VanessaMCOutsideBus_11);
    mc.think(`Or is straight up ignoring her.`);
    doWaitImageByTime(images.v9.V9VanessaMCOutsideBus_12);
    mc.think(`She finally caught his attention.`);
    doWaitImageByTime(images.v9.V9VanessaMCOutsideBus_13);
    mc.think(`And she got what she wants.`);
    doLoopImages([images.v9.V9VanessaMCOutsideBus_14, images.v9.V9VanessaMCOutsideBus_15], 0.5);
    // Put these thoughts
    mc.think(`Why do these things never happen to me?`);
    mc.think(`Maybe because I never take the bus...?`);
    mc.think(`Or maybe because Vanessa is one of a kind...?`);
    ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_38);
    vanessa.talk(`Oh look! This is my stop!`);
    ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_37);
    await stranger.set((properties) => {
        stranger.name = "Stranger";
    });
    stranger.talk(`Are you serious?`);
    vanessa.talk(`Bye!`);

    if (isFollowingVanessaLead()) {
        await endReplay(replayScenesList.V9VanessaBusMoveSeat);
    } else {

        await endReplay(replayScenesList.V9VanessaBus);
    }


    return jump(V9VanessaBus_End, "V9VanessaBus_End");
};
export const v9VanessaBusMcLeadingOptionsStayPut = async (): Promise<any> => {
    ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_34, { putParent: true });
    mc.talk(`We almost got caught!`);
    ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_36);
    vanessa.talk(`So?`);
    ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_34, { putParent: true });
    mc.talk(`I'd like not to get a criminal record for exposing myself in public.`);
    mc.talk(`Maybe you are safe because you are a chick. I'd actually get in trouble.`);
    ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_36);
    vanessa.talk(`Don't worry. I'd bail you out.`);
    ImageClass.setImage(images.v9.V9VanessaMCOutsideBus_1.partials.V9VanessaMCOutsideBus_34, { putParent: true });
    mc.talk(`Yeah... I don't buy it.`);

    await endReplay(replayScenesList.V9VanessaBus);
    return jump(V9VanessaBus_End, "V9VanessaBus_End");
};

export const V9VanessaBus_End = async (): Promise<any> => {
    // safeguard for finishing replay
    await endReplay();
    return jump(V9VanessaBusAfter, "V9VanessaBusAfter");
};







